import { Box, formatDate, getSpacing, Typography } from "@compass/core";
import { MatchDataProvider, useMatchData } from "../contexts";
import { DashboardPieChart } from "./DashboardPieChart";
import { DashboardCard } from "../components/DashboardCard";
import { DashboardChartViewSelect } from "../components/DashboardChartViewSelect";
import { DASHBOARD_CHART_VIEW_CONFIG, DashboardChartView } from "../types";
import { useState } from "react";


const MatchChartCardContent = () => {
    const { pieChartRows, loading, reportDateFrom, reportDateTo } = useMatchData();
    const [chartView, setChartView] = useState<DashboardChartView>(DASHBOARD_CHART_VIEW_CONFIG.match.recommendedView);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}><DashboardChartViewSelect dashboard="match" value={chartView} onChange={setChartView} /></Box>
            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <DashboardPieChart rows={pieChartRows} loading={loading} chartView={chartView} />
            </Box>
            <Box pt={getSpacing("lg")}>
                <Typography variant="caption">
                    Report dates: {formatDate(reportDateFrom)}
                    <> to </>
                    {formatDate(reportDateTo)}
                </Typography>
            </Box>
        </Box>
    );
};

export const MatchChartCard = () => {
    return (
        <MatchDataProvider>
            <DashboardCard title="Match Contribution">
                <MatchChartCardContent />
            </DashboardCard>
        </MatchDataProvider>
    );
};
